/**
 * De volgorde waarin een begeleider zijn werk wil zien. Lager = eerder.
 *
 * 'complete' en 'unknown' staan er niet in: die horen niet op een doen-lijst.
 * Bij 'unknown' weten we niet wie invulde, en iemand aansporen die misschien
 * allang klaar is kost de lijst zijn geloofwaardigheid.
 */
const URGENCY_ORDER = {
    overdue: 0,
    due: 1,
    open: 2,
    upcoming: 3,
    waiting: 4,
}

/**
 * De rijen die om actie vragen, met de langst wachtende bovenaan.
 *
 * Sorteren op wachttijd werkt zonder enige ingestelde grens — dat is precies
 * waarom de signalering niets hoeft te weten over termijnen om nuttig te zijn.
 *
 * Een onbekende wachttijd sorteert achteraan, niet vooraan: '—' is geen nul.
 * AI-CONTEXT: See docs/pitfalls.md#ui-display-fallback-used-as-sort-key
 *
 * @param {Array<import('./buildMeasurementSignals').MeasurementSignalRow>} [rows]
 * @returns {Array<import('./buildMeasurementSignals').MeasurementSignalRow>}
 */
const selectUpcomingSignals = (rows) => (rows || [])
    .filter((row) => row && row.active && row.next && row.urgency in URGENCY_ORDER)
    .sort((a, b) => {
        const byUrgency = URGENCY_ORDER[a.urgency] - URGENCY_ORDER[b.urgency]
        if (byUrgency !== 0) return byUrgency
        const aDays = typeof a.openDays === 'number' ? a.openDays : -1
        const bDays = typeof b.openDays === 'number' ? b.openDays : -1
        return bDays - aDays
    })

export default selectUpcomingSignals
export { URGENCY_ORDER }
